<style lang="scss" scoped>
@import "@/styles/mixins.scss";
.el-input {
  width: 200px;
}
.programOperation {
  // width: 1020px;
  width: 100%;
  margin: 0 auto;
  background-color: white;
  padding: 10px 0;
  .operateBtn .el-button {
    background-color: #74b9ff;
    border-color: #74b9ff;
    width: 250px;
    height: 36px;
    padding: 0;
    line-height: 36px;
  }
}
.editorWrapper {
  background: #f1f1f1;
  padding: 10px 10px 10px;
  margin: 10px;
  position: relative;
  .editorTop {
    margin: 10px 0;
  }
  .editorInnerWrapper {
    height: 400px;
    display: grid;
    width: 100%;
    box-sizing: border-box;
    grid-template-columns: 1fr 1fr;
    column-gap: 10px;
    overflow: auto;
  }
  .ace_editor {
    width: 100% !important;
    height: 100% !important;
  }
  &.focused {
    .editorInnerWrapper {
      grid-template-columns: 1fr;
    }
  }
}

.fileNames {
  text-align: left;
  padding: 0 20px;
  .el-select {
    margin-right: 10px;
  }
  i.el-icon-circle-plus {
    font-size: 20px;
    &:hover {
      cursor: pointer;
    }
  }
}
.mockFS {
  width: 100%;
  border-radius: 4px;
  background-color: white;
  overflow: auto;
  position: relative;
  .fileNameWrapper {
  }
  .fileContentWrapper {
    // position: relative;
    // padding-top: 10px;
    position: absolute;
    top: 60px;
    left: 0;
    bottom: 0;
    width: 100%;
    box-sizing: border-box;
    p {
      margin: 0;
    }
    textarea {
      padding: 0;
      width: 100%;
      height: 99%;
      border: 1px dashed #aaa;
      box-sizing: border-box;
    }
  }
}

.codeResult {
  width: 100%;
  border-radius: 4px;
  background-color: white;
  overflow: auto;
  position: relative;
  display: flex;
  flex-direction: column;
  .textOutput {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    text-align: left;
    flex: 1;
    min-height: 200px;
    overflow: auto;
    padding: 0 10px;
    margin: 20px 10px;
    @include customScrollBar(6px, transparent, #dcdfe6, #c2c5cc, 4px);
    pre {
      font-size: 14px;
      line-height: 1.2;
    }
  }
}
.editorTop {
  box-sizing: border-box;
  display: grid;
  // width: 100%;
  grid-template-columns: 100px 100px 300px 1fr ;
  .files{
    text-align: left;
    display: flex;
    span {
      line-height: 22px;
      background-color: #fff;
      padding: 5px;
      margin-left: 10px;
    }
  }
}
.runCode {
  color: white;
  background-color: #74b9ff;
}
.clearCode {
  border: none;
  color: #74b9ff;
}
.fullEditor {
  grid-column-start: 5;
  grid-column-end: 6;
  font-size: 20px;
  padding: 0;
  color: black;
  font-weight: bold;
}
.submitAnswer {
  grid-column-start: 3;
  grid-column-end: 4;
  background-color: #ffc831;
  border: none;
  color: #ad6012;
}
.fullEditorWrapper {
  position: fixed;
  z-index: 2;
  width: 100%;
  box-sizing: border-box;
  top: 70px;
  bottom: 0;
  left: 0;
  // padding: 0 10px;
  // background-color: rgba(0,0,0,0.3);
  background-color: #f1f1f1;
  .editorTop {
    margin: 20px 0;
    height: 35px;
  }
  .ace_editor {
    width: 100% !important;
    height: 100% !important;
  }
  .editorInnerWrapper {
    display: grid;
    width: 100%;
    box-sizing: border-box;
    grid-template-columns: 6fr 4fr;
    column-gap: 10px;
    top: 75px;
    bottom: 0;
    position: absolute;
  }
}
.editorInnerWrapper {
  display: flex;
  width: 100%;
  box-sizing: border-box;
}

::v-deep .oldPrompt {
  color: #74b9ff;
  border: none;
  outline: none;
}

.console{
  width: 100%;
}

.toggleCanvasBtn {
  position: absolute;
  left: 10px;
  top: 0;
  color: black;
  font-size: 24px;
}
.restrictResult {
  width: 500px;
  height: 400px;
}
.restrictCanvas{
  position: absolute;
  height: 100%;
  .console{
    width: 400px;
  }
}
::v-deep .el-loading-mask{
  background-color: rgba(255,255,255,0.5);
  svg{
    width: 30px;
    height: 30px;
  }
  .el-loading-spinner{
    margin-top: -15px;
  }
}
</style>
<template>
  <div class="programOperation">
    <div :class="{editorWrapper:!showFull,fullEditorWrapper: showFull, focused: focusing}">
      <div class="editorTop">
        <el-button v-loading="running" @click="handleRunCode" class="runCode" size="small">运行</el-button>
        <el-button @click="handleClear" class="clearCode" size="small">清除</el-button>
        <div class="fileNames">
          <el-select
            @change="handleSelectFile"
            v-model="currentFile"
            :placeholder="Object.entries(mockFiles).length?'请选择要修改的文件':'点击+创建新文件'"
          >
            <el-option
              :value="entry[0]"
              slot
              v-for="(entry, index) in Object.entries(mockFiles)"
              :key="index"
              :label="entry[0]"
            ></el-option>
          </el-select>
          <i title="新建文件" @click="createNewFile" class="el-icon-circle-plus"></i>
        </div>
        <!-- <el-button
          @click="handleFullEditor"
          class="fullEditor"
          size="small"
          icon="el-icon-rank"
          type="text"
        ></el-button> -->
      </div>
      <div class="editorInnerWrapper">
        <base-editor
          :code.sync="editorSetting.code"
          :width="editorSetting.width"
          :height="editorSetting.height"
          :theme="editorSetting.theme"
          :lang="editorSetting.lang"
          @init="editorInit"
        ></base-editor>
        <!-- <div class="codeResult" v-show="!focusing || showFull">
          <div ref="codeResult"></div>
          <div id="console" ref="console"></div>
        </div> -->
        <div :class="{codeResult:true, restrictResult: !showFull, restrictCanvas: canvasExpanded}" v-show="!editingFile">
          <el-button v-if="showFull" class="toggleCanvasBtn" type="text" :icon="canvasExpanded ? 'el-icon-zoom-out' :'el-icon-zoom-in'" @click="handleToggleCanvas"></el-button>
          <p>输出</p>
          <div class="textOutput">
            <pre ref='codeResult'></pre>
          </div>
          <div class="console" id="console" ref="console"></div>
          <!-- 代码运行结果 -->
        </div>
        <div class="mockFS" v-show="editingFile">
          <!-- 利用textare模拟文件系统 -->
          <div class="fileNameWrapper">
            <p>
              文件名：
              <el-input type="text" @blur="handleFileNameEditBlur" v-model="nameInEdit"></el-input>
            </p>
          </div>
          <template v-for="(entry, index) in Object.entries(mockFiles)">
            <div v-show="entry[0] === currentFile" class="fileContentWrapper" :key="index">
              <!-- <p>
                文件名:
                <input :id="`file-${index}`">
                <el-input
                  @change="handleFileNameChange(`file-${index}`,$event)"
                  :id="`file-${index}`"
                  size="small"
                  @blur="handleFileNameBlur($event)"
                ></el-input>
              </p>-->
              <textarea v-model="mockFiles[entry[0]]" :id="entry[0]"></textarea>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseEditor from '@/components/BaseEditor.vue';

export default {
  data() {
    return {
      editor: null,
      editorSetting: {
        // code: 'n1=open("password.txt")\ncontent=n1.read()\nprint(content)',
        code: '',
        height: 0,
        width: 0,
        theme: 'textmate',
        lang: 'python',
      },
      focusing: false,
      showFull: true,
      baseUrl: process.env.BASE_URL,
      running: false,
      editing: false,
      mockFiles: {
        // '新建文件.txt': '12334348',
        // '新建文件2.txt': '12334347',
        // '新建文件3.txt': '12334346',
        // '新建文件4.txt': '12334345',
      },
       currentFile: '',
      editingFile: false,
      createCount: 0,
      nameInEdit: '',
      canvasExpanded: false,
    };
  },
  methods: {
    editorInit(editor) {
      editor.on('focus', (e) => {
        this.focusing = true;
          this.currentFile = ''; // 使文件编辑失去显示
        this.editingFile = false;
      });
      editor.on('blur', (e) => {
        this.focusing = false;
      });
      require('brace/ext/language_tools');
      require('brace/mode/python');
      require('brace/snippets/python');
      require('brace/theme/clouds');
      require('brace/theme/textmate');
      require('brace/theme/monokai');
      this.editor = editor;
    },
    saveCode() {
      const { code } = this.editorSetting;
    },
    handleFullEditor() {
      this.showFull = !this.showFull;
      this.$nextTick(() => {
        this.editor.resize();
      });
    },
    handleExitFullEditor() {
      this.showFull = false;
    },
    handleUpdateCode(e) {
      console.log(e, 'listen update option');
    },
    outf(text) {
      // if (text && text != '\n') {
      //   const str = text.replace(
      //     /[<>&"]/g,
      //     c => ({
      //         '<': '&lt;',
      //         '>': '&gt;',
      //         '&': '&amp;',
      //         '"': '&quot;',
      //         '\n': '<br/>',
      //         ' ':'&nbsp;',
      //         '\t':'&nbsp;&nbsp;&nbsp;&nbsp;'
      //       }[c]),
      //   );
      //   // this.$refs.codeResult.innerHTML += `<pre style='color:black;font-size: 16px;white-space:pre;margin:0'>${str}</pre>`;
      //   console.log(str);
      //   const p = document.createElement('p');
      //   p.className = 'outputItem';
        // p.innerHTML = str;
        // this.$refs.codeResult.appendChild(p);
        // this.$refs.error.innerHTML += "<p>"+text+"</p>";
      const span = document.createElement('span');
      span.innerHTML = text;
      this.$refs.codeResult.appendChild(span);
      // }
    },
    builtinRead(x) {
      if (
        Sk.builtinFiles === undefined
        || Sk.builtinFiles.files[x] === undefined
      ) {
        throw `File not found: '${x}'`;
      }
      return Sk.builtinFiles.files[x];
    },
    execRun() {
      // const { code } = this.editorSetting;
      const code = this.editor.getValue();
      console.log(code);
      this.editorSetting.code = code;
      this.$refs.codeResult.innerHTML = '';
      Sk.pre = 'output';
      // Sk.python3 = true;
      const vm = this;
      this.running = true;
      let scale;

      if (this.showFull) {
        scale = {
          width: 1000,
          height: 1000,
        };
      } else {
        scale = {
          width: 400,
          height: 400,
        };
      }
      Sk.configure({
        output: vm.outf,
        read: vm.builtinRead,
        inputfun: vm.buildMyInput,
        inputfunTakesPrompt: true,
        __future__: Sk.python3,
        filewrite: vm.fileWrite,
        killableWhile: true,
        killableFor: true,
        execLimit: null, // disable
      });
      // Sk.TurtleGraphics || (Sk.TurtleGraphics = scale)

      (
        Sk.TurtleGraphics || (Sk.TurtleGraphics = { width: 1200, height: 700 })
      ).target = 'console';
      const myPromise = Sk.misceval.asyncToPromise(() => Sk.importMainWithBody('<stdin>', false, code, true));
      console.log(Sk);
      myPromise.then(
        (mod) => {
          vm.running = false;
          // console.log(document.getElementsByTagName('canvas')[0].style.marginTop);
          // if (document.getElementsByTagName('canvas')[0].style.marginTop == '-780px') {
          //     // document.getElementsByTagName('canvas')[0].style.marginTop = '0px';
          // }
        },
        (err) => {
          console.log(err);
          vm.running = false;
          vm.$refs.codeResult.innerHTML = `<span style='color: red'>${err}</span>`;
        },
      );
    },
    handleRunCode() {
      if (!this.running) {
        this.execRun();
      } else {
        // const timer = setInterval(() => {
        //   if (!this.running) {
        //     this.execRun();
        //     clearInterval(timer);
        //   }
        // }, 200);
        this.$message.warning('代码运行中，点击清除可以提前结束运行。');
      }
      const consoleWrapper = document.getElementById('console'); // querySelector 选择数字开头的id需要escape
      setTimeout(() => {
        const canvas = consoleWrapper.querySelector('canvas');
          if (canvas) {
          canvas.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'center',
          });
        }
      }, 0);
    },
    buildMyInput(a) {
      console.log(a); // input里面传进来的内容
      const input = `${a}:<input type='text'/>`;
      const p = document.createElement('p');
      p.innerHTML = input;
      p.style.margin = 0;
      this.$refs.codeResult.appendChild(p);
      return new Promise((resolve, reject) => {
        // const input = 'hm';
        const inputDom = p.querySelector('input');
        inputDom.focus();
        inputDom.addEventListener('keyup', (e) => {
          if (e.keyCode === 13) {
            e.target.className = 'oldPrompt';
            e.target.setAttribute('readonly', true);
            // inputDom.disabled = true;
            resolve(e.target.value);
          }
        });
        // resolve(input);
      });
    },
    handleClear() {
      // this.cleartip = '清除中...';
      // setTimeout(() => {
      // this.editorSetting.code = '';
      // console.log(Sk.TurtleGraphics, Sk);
      // Sk.TurtleGraphics.stop(); // 这是一个运行时属性，就是说只有在turtule还在绘制，那个promise没有resolve的时候才能访问到，过期就会呗删除
      if (Sk.TurtleGraphics && typeof Sk.TurtleGraphics.reset === 'function') {
        Sk.TurtleGraphics.reset();
      }
      this.running = false;
      this.$refs.codeResult.innerHTML = '';
      this.$refs.console.innerHTML = '';
      // this.cleartip = '清除';
      // }, 500);
    },
    handleSubmit() {
    },
    handleEdit(e) {
      console.log(e.value, e.target.innerText);
    },
    handleSelectFile() {
      this.editingFile = true;
      this.$nextTick(() => {
        this.nameInEdit = this.currentFile;
      });
    },
    createNewFile() {
      this.editingFile = true;
      const filename = this.validateFileName('新建文件.txt', this.mockFiles);
      this.currentFile = filename;
      this.nameInEdit = filename;
      this.$set(this.mockFiles, filename, '');
    },
    handleFileNameEditBlur() {
      if (!this.nameInEdit) {
        this.$message.error('文件名不能为空');
        this.nameInEdit = this.currentFile;
      } else if (
        this.mockFiles[this.nameInEdit]
        && this.nameInEdit !== this.currentFile
      ) {
        this.$message.error('文件名不能相同');
        this.nameInEdit = this.currentFile;
      } else {
        console.log(this.currentFile,this.nameInEdit);
        this.$set(
          this.mockFiles,
          this.nameInEdit,
          this.mockFiles[this.currentFile],
        );
        if (this.currentFile !== this.nameInEdit) {//失去焦点后如果文件名更改了
          this.$delete(this.mockFiles, this.currentFile);
        }
        // this.$delete(this.mockFiles, this.currentFile);
        this.currentFile = this.nameInEdit;
      }
    },
    validateFileName(name, fileList) {
      console.log(name, fileList);
      let count = 0;
      let finalName = name;
      while (fileList[finalName] !== undefined) {
        count += 1;
        const lastIndexOfDot = name.lastIndexOf('.');
        finalName = `${name.slice(0, lastIndexOfDot)}(${count})${name.slice(lastIndexOfDot)}`;
      }
      return finalName;
    },
    onMessageHandler(e) {
      if (e.origin === location.origin || e.origin.endsWith(process.env.VUE_APP_B2B_DOMAIN)) {
        switch (e.data.event) {
          case 'CODE':
            console.log(e.data);
            this.editorSetting.code = e.data.code;
            if (e.data.file.json_url !== undefined) {
              this.fetchTxtFromUrl(e.data.file.json_url,e.data.file.name);
            }
            break;
          default:
            break;
        }
      }
    },
    cusFileWrite(self, str, mode) {
      // this.mockFiles[self.name] = str.v;
      // this.mockFiles[self.name] = `${this.mockFiles[self.name]}${str.v}\n`;
      console.log(self, str, mode);
      if (self.closed) {
        throw new Error("Cant't write with file closed");
      }
      switch (mode) {
        case 'w': //覆盖写模式
          // console.log(self.name, str.v, mode);
          this.mockFiles[self.name] = str.v;
          break;
        case 'a': // append模式
          this.mockFiles[self.name] = `${this.mockFiles[self.name]}${str.v}\n`;
          break;
        case 'r':
          throw new Error("Can't write in mode r"); // this error can be output in output
        default:
      }
    },
    fileWrite(self, str) {
      switch (self.mode.v) {
        case 'w': //覆盖写模式
          // console.log(self.name, str.v, mode);
          this.mockFiles[self.name] = str.v;
          break;
        case 'a': // append模式
          this.mockFiles[self.name] = `${this.mockFiles[self.name]}${str.v}\n`;
          break;
        case 'r':
          throw new Error("Can't write in mode r"); // this error can be output in output
        default:
      }
    },
    handleToggleCanvas() {
      this.canvasExpanded = !this.canvasExpanded;
    },
    async fetchTxtFromUrl(url, fileName) {
      const utf8Decoder = new TextDecoder('utf-8');
      // const utf8Decoder = new TextDecoder('ISO-8859-2');
      const response = await fetch(url);
      const reader = response.body.getReader();
      let { value: chunk, done: readerDone } = await reader.read();
      chunk = chunk ? utf8Decoder.decode(chunk) : '';
      this.$set(this.mockFiles, fileName, chunk);
    },
  },
  components: {
    BaseEditor,
  },
  created() {
    const {opener} = window;
    if (opener) {
      opener.postMessage({
        event: 'IDE_LOADED'
      }, '*');
    }
    window.addEventListener('message', this.onMessageHandler);
  },
  mounted() {

  },
  props: {
  },
  watch: {},
};
</script>
